import { ApiError } from './models';

export interface ApiRequestFailureEvent {
    url: string;
    error: unknown;
}

export interface ApiRequestSuccessEvent {
    url: string;
}

type ApiRequestFailureListener = (event: ApiRequestFailureEvent) => void;
type ApiRequestSuccessListener = (event: ApiRequestSuccessEvent) => void;

const failureListeners = new Set<ApiRequestFailureListener>();
const successListeners = new Set<ApiRequestSuccessListener>();

export function isNetworkRelatedError(error: unknown): boolean {
    if (error instanceof TypeError) {
        return true;
    }

    if (error instanceof ApiError) {
        if (error.code === undefined) {
            return true;
        }

        return error.code >= 500;
    }

    return false;
}

export function isTelloportBackendUrl(url: string): boolean {
    return url.includes('iot-api');
}

export function registerApiRequestFailureListener(listener: ApiRequestFailureListener): () => void {
    failureListeners.add(listener);
    return () => failureListeners.delete(listener);
}

export function registerApiRequestSuccessListener(listener: ApiRequestSuccessListener): () => void {
    successListeners.add(listener);
    return () => successListeners.delete(listener);
}

export function notifyApiRequestFailure(url: string, error: unknown): void {
    if (!isNetworkRelatedError(error)) {
        return;
    }

    const event = { url, error };
    failureListeners.forEach((listener) => listener(event));
}

export function notifyApiRequestSuccess(url: string): void {
    const event = { url };
    successListeners.forEach((listener) => listener(event));
}
